import { jsx } from 'react/jsx-runtime';
import { ACCESSIBILITY_TYPE, Popover } from 'baseui/popover';
import { mergeOverrides } from '../../overrides.js';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultTooltipProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  "data-baseweb": "tooltip",
  showArrow: true,
  autoFocus: false,
  popoverMargin: 4,
  onMouseEnterDelay: 100,
  onMouseLeaveDelay: 100,
  triggerType: "hover"
};
const Tooltip = (_a) => {
  var _b = _a, { overrides, $style, disabled, isOpen } = _b, props = __objRest(_b, ["overrides", "$style", "disabled", "isOpen"]);
  const resolvedStyle = useResolvedStyle($style);
  return jsx(Popover, __spreadValues(__spreadProps(__spreadValues({}, defaultTooltipProps), { overrides: mergeOverrides({
    Body: {
      style: ({ $theme }) => mergeStyles({
        backgroundColor: $theme.colors["background-global-inverse"],
        color: $theme.colors["text-global-inverse"],
        boxShadow: "none",
        zIndex: $theme.zIndices.tooltip
      }, resolvedStyle)
    },
    Arrow: {
      style: {
        backgroundColor: "inherit"
      }
    },
    Inner: {
      style: ({ $theme }) => __spreadProps(__spreadValues({}, $theme.typography.p4), {
        backgroundColor: "inherit",
        color: "inherit",
        borderTopLeftRadius: $theme.radii[4],
        borderTopRightRadius: $theme.radii[4],
        borderBottomLeftRadius: $theme.radii[4],
        borderBottomRightRadius: $theme.radii[4],
        paddingTop: $theme.space[8],
        paddingBottom: $theme.space[8],
        paddingLeft: $theme.space[16],
        paddingRight: $theme.space[16]
      })
    }
  }, overrides), isOpen: !disabled && isOpen }), props));
};

export { Tooltip, defaultTooltipProps };
